import { FC } from "react";
import { Icon } from "../Icon/Icon";
import Paragraph from "../typography/Paragraph";
import Badge from "./Badge/Badge";
import { ISearchResultItem } from "../../hooks/useSearch";
import {
    StyledSearchResultList,
    StyledSearchResultItem,
    StyledLink,
    StyledImageWrapper,
    StyledSearchResultInfo,
    StyledBadges,
    StyledBadge,
    StyledImage,
} from "./SearchResultList.style";
import { removeNbsp } from "../../helpers/utils";
import { ReactComponent as HammerIcon } from "../../assets/icons/hammer.svg";

interface ISearchResult {
    isMobile: boolean;
    pageUrl: string;
    pageName: string;
    searchResult: ISearchResultItem[] | undefined;
}

export const SearchResultList: FC<ISearchResult> = (props): JSX.Element => {
        const { isMobile, searchResult, pageUrl } = props;

    //TODO: find out for what is pageName here

    return (
        <StyledSearchResultList>
            {searchResult?.map(({ id, name, state_code, obligee_name, bond_preview_url, descr }) => {
            const params = new URLSearchParams(window.location.search);
            // Remove search-form params so links don't include the current search filters
            params.delete("q");
            params.delete("state");
            params.delete("category");
            params.set("id", String(id));
            params.set("sc", String(state_code));
            const href = `${pageUrl}/application-form?${params.toString()}`;

                return (
                    <StyledSearchResultItem key={id}>
                        <StyledImageWrapper>
                            <StyledLink href={href}>
                                <StyledImage src={bond_preview_url}></StyledImage>
                            </StyledLink>
                        </StyledImageWrapper>
                        <StyledSearchResultInfo>
                            <StyledLink href={href}>
                                <Paragraph size={28} weight={500} color="badge-link">
                                    {name}
                                </Paragraph>
                            </StyledLink>
                            <Paragraph
                                size={16}
                                weight={500}
                                lineHeight="1.5em"
                                color="black"
                            >
                                {removeNbsp(descr)}
                            </Paragraph>
                            <StyledBadges>
                                <StyledBadge>
                                    <Badge icon={<Icon name="flag" size={16} />}>
                                        {state_code}
                                    </Badge>
                                </StyledBadge>
                                {obligee_name && (
                                    <Badge icon={<HammerIcon />}>
                                        {obligee_name}
                                    </Badge>
                                )}
                            </StyledBadges>
                        </StyledSearchResultInfo>
                    </StyledSearchResultItem>
                )
            })}
        </StyledSearchResultList>
    );
};
